import React from 'react'
import { Glyphicon } from 'react-bootstrap'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Button = styled.button`
  background: none;
  border: none;
  outline: none;
`

const CrossButton = ({ onClick, title }) => (
  <Button onClick={onClick} title={title} >
    <Glyphicon glyph="remove" />
  </Button>
)

CrossButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default CrossButton



// WEBPACK FOOTER //
// ./src/components/CrossButton.js